// extracted by mini-css-extract-plugin
export var ContactData = "ContactData-module--ContactData--57420";
export var DataContainer = "ContactData-module--DataContainer--40e6a";
export var Link = "ContactData-module--Link--402d2";
export var SectionData = "ContactData-module--SectionData--7de04";
export var Socials = "ContactData-module--Socials--8d7e1";
export var p2 = "ContactData-module--p2--e4895";
export var title = "ContactData-module--title--d21de";